<template>
    <div
        v-if="hasWritePermissions || isDemoUser"
        class="vrm-circle-icon-button vrm-ai-assistant-overlay-button"
        @click="openAIAssistantView"
    >
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 23"
            fill="#FCFCFC"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5 20.1604L2.4125 22.6668C2.05625 23.0119 1.64825 23.0889 1.1885 22.8979C0.7295 22.7075 0.5 22.3672 0.5 21.8768V4.90388C0.5 4.30452 0.7205 3.79125 1.1615 3.36406C1.60175 2.93761 2.13125 2.72438 2.75 2.72438H11.5812C11.5062 3.08763 11.4687 3.45088 11.4687 3.81413C11.4687 4.17738 11.5062 4.54063 11.5812 4.90388H2.75V17.9809H16.7187V10.7885C17.15 10.6977 17.5531 10.575 17.9281 10.4202C18.3031 10.2662 18.65 10.062 18.9687 9.80777V17.9809C18.9687 18.5803 18.7486 19.0935 18.3084 19.5207C17.8674 19.9472 17.3375 20.1604 16.7187 20.1604H5Z"
            />
            <path
                id="vrm-ai-assistant-overlay-button__icon-sparkle"
                d="M19.0899 6.20184L17.9765 8.5911C17.7228 9.12357 16.9335 9.12357 16.6798 8.5911L15.5663 6.18819L13.0998 5.10961C12.5501 4.86385 12.5501 4.11294 13.0998 3.86719L15.5804 2.78861L16.6939 0.399348C16.9476 -0.133116 17.7228 -0.133116 17.9765 0.399348L19.0899 2.80226L21.5565 3.88084C22.1062 4.1266 22.1062 4.87751 21.5565 5.12326L19.0899 6.20184Z"
            />
            <path
                d="M24.5 10.3526C24.5 11.3557 23.6605 12.1689 22.625 12.1689C21.5895 12.1689 20.75 11.3557 20.75 10.3526C20.75 9.34955 21.5895 8.53639 22.625 8.53639C23.6605 8.53639 24.5 9.34955 24.5 10.3526Z"
            />
            <path
                d="M23.3368 16.1277L22.887 17.0931C22.7845 17.3082 22.4655 17.3082 22.363 17.0931L21.9132 16.1222L20.9166 15.6864C20.6945 15.5871 20.6945 15.2837 20.9166 15.1844L21.9188 14.7486L22.3687 13.7832C22.4712 13.5681 22.7845 13.5681 22.887 13.7832L23.3368 14.7541L24.3334 15.1899C24.5555 15.2892 24.5555 15.5926 24.3334 15.6919L23.3368 16.1277Z"
            />
        </svg>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { ngInject } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-ai-assistant-overlay-button')
export default class VrmAIAssistantOverlayButton extends Vue {
    @ngInject()
    InstallationsService;
    @ngInject()
    UserService;
    @ngInject()
    vrmUserAccessLevel;

    isDemoUser = false;

    get hasWritePermissions() {
        return (
            this.installation &&
            this.installation.view_permissions &&
            this.installation.view_permissions.update_settings
        );
    }

    get installation() {
        return this.InstallationsService.activeInstallation;
    }

    async mounted() {
        window.addEventListener('open-ai-assistant-view', this.openAIAssistantView);
        this.isDemoUser = await this.isDemo();
    }

    beforeDestroy() {
        window.removeEventListener('open-ai-assistant-view', this.openAIAssistantView);
    }

    async isDemo() {
        await this.UserService.getUser();
        return this.UserService.user.accessLevel === this.vrmUserAccessLevel.DEMO;
    }

    openAIAssistantView() {
        // Save the current route name so we can redirect back to it after the AI assistant is closed
        localStorage.setItem('vrm-ai-assistant-redirected-from', this.$route.name);
        this.$router.push({ name: 'ai-assistant', params: { id: this.$route.params.id } });
    }
}
</script>
